export const languageAvailabe = ['en', 'hi'];

export const mutliLng = {
    "en": {

        // #############Home

        "select_language": "Select Language",

        "chirayu_haryana_pmjay": "CHIRAYU HARYANA PMJAY",

        "nominal_contribution_collection": "Nominal Contribution Collection",

        "click_to_apply": "Click to Apply",

        "undertaking": "UNDERTAKING",

        "undertaking_intro": "I hereby declare and undertake that I have read and understood the following terms and conditions regarding my enrolment under the CHIRAYU – Ayushman Bharat PM-JAY Scheme:",

        "pmjay_chirayu": "1. Under the CHIRAYU – Ayushman Bharat PM-JAY Scheme, empanelled hospitals will provide cashless secondary and tertiary healthcare services up to ₹5,00,000 (Rupees Five Lakh) per family per year, subject to the applicable scheme guidelines.",

        "under_the_scherme": "2. The eligibility of the beneficiary family shall be determined on the basis of the verified annual family income recorded in the Family ID (Parivar Pehchan Patra – PPP ID). The applicable annual registration fee is as follows:",

        "fee_table_income_header": "Verified Annual Family Income",

        "fee_table_fee_header": "Registration Fee per Family per Annum",

        "fee_slab_1_income": "₹1.80 lakh up to ₹3.00 lakh",

        "fee_slab_1_fee": "₹1,500/-",

        "fee_slab_2_income": "Above ₹3.00 lakh up to ₹6.00 lakh",

        "fee_slab_2_fee": "₹4,000/-",

        "fee_slab_3_income": "Above ₹6.00 lakh",

        "fee_slab_3_fee": "₹5,000/-",

        "a_nominal_contribution": "3. I understand that, as an eligible beneficiary family, I am required to deposit the applicable annual registration fee for availing coverage under the CHIRAYU Scheme.",

        "portal_open_until": "4. I understand that the portal for payment of the applicable registration fee shall remain open up to 30.11.2026. After the prescribed deadline, the portal shall be closed and payment/enrolment shall not be possible through the portal, subject to applicable orders/guidelines.",

        // "baneficiary_family_shall": "4. Beneficiary families shall pay the nominal contribution-cum-registration fees from 15/08/2023 and continue until we provide further notice.",

        "after_successful": "5. Upon successful verification of eligibility and receipt of the applicable registration fee, the CHIRAYU Card/coverage shall remain valid from 01.11.2026 to 31.10.2027, subject to the applicable scheme guidelines and conditions.",

        "during_validity_period": "6. During the validity period, I and the eligible members of my family shall be entitled to avail cashless treatment at empanelled hospitals, subject to the package, eligibility, and other terms and conditions applicable under the scheme.",

        "confirm_ppp_information": "7. I hereby confirm that the information available against my Family ID (PPP ID) is correct to the best of my knowledge. I understand that eligibility for the scheme and the applicable registration fee shall be determined on the basis of the verified information available in the prescribed system/portal.",

        "six_line": "5. Any beneficiary family that makes a payment between 1st January to 31st March, 2024 will begin receiving benefits from April 1, 2024.",


        "voluntarily_deposit_fee": "8. I hereby voluntarily deposit the applicable registration fee and agree to abide by the terms and conditions of the CHIRAYU – Ayushman Bharat PM-JAY Scheme.",

        "i_hereby_submit": "I have carefully read and understood all the above-mentioned terms and conditions. I hereby give my full consent to be enrolled under the PM-JAY Chirayu Scheme for availing healthcare benefits, subject to successful verification and payment of the registration fee.",

        "agree_and_continue": "Agree & Continue",

        "please_accept_the": "Please accept the Terms and Conditions",

        // I hereby submit that I understand above Terms and Conditions and give my consent for enrollment under the scheme upon successful verification and payment.



        // ###############transaction enq

        "no_data_found": "No Data Found",

        "transaction_id_length_exceed": "Transaction ID length exceed",

        "required": "Required",

        "transaction_id": "Transaction ID",

        "ppp_id": "PPP ID",

        "print": "Print",

        "close": "Close",





        //############ppp-verification - VerifyDetails

        "enter_the_otp": "Enter the valid OTP",

        "enter_details": "Enter Details",

        "please_enter_ppp_id": "Please enter PPP ID",

        "ppp_id_length_exceed": "PPP ID length exceed",

        "please_enter_uid": "Please enter UID",

        "invalid_uid": "Invalid UID",

        "enter_valid_8_digit_ppp": "Enter the Valid 8 digit PPP ID",

        "uid_required": "UID is required",

        "your_pppid_aadhar": "Your PPP ID/ Aadhar Number",

        "search_ppp_id": "Your PPP ID",

        "search_aadhar_number": "Your UID",

        "otp_length": "OTP should be 6 digit only",

        "enter_uid": "Enter the UID",

        "verified": "Verified",

        "verify": "Verify",

        "submit": "Submit",

        "we_will_send_you_a": "We will send you a verification code on registered mobile number to verify the PPP ID",

        "continue": "Continue",

        "enter_the_pppid_or_aadhar_num": "Enter PPP ID",

        "i_forgot_my_ppp": " I forgot my PPP ID (Search it via UID)",

        "please_select_the_option": "Please select the option",

        "otp_verification": "OTP Verification",

        "enter_otp": "Enter the OTP",

        "do_not_recevie_the_otp": "Didn't receive the OTP?",

        "resend": "Resend",

        // "verify": "Verify",

        "aadhar_number": "Aadhar Number",







        //###########preview-details

        "ppp_details": "PPP Details",

        "ppp_id_number": "PPP ID Number",

        "id": "ID",

        "name": "Name ",

        "district": "District",

        "sub_district": "Sub-District",

        "linked_member_info": "Linked Member Info",

        "proceed_further_for_payment": "Proceed further for payment",

        "note_for_pppid_related": "Note: For PPP ID related grievance (https://grievance.edisha.gov.in/)",

        "check_eligibility": "Check Eligibility",

        "family_head_name": "Family Head Name",

        "address": "Address",

        "family_income": "Family Income",





        //################ payment-handler

        "payment_details": "Payment Details",

        "payment_for": "Payment For",

        // "ppp_id" : "PPP ID",

        "amount_to_be_paid": "Amount to be paid",

        "currency": "₹",

        "payment_partner": "Payment Partner Canara Bank",
        "payment_partner_csc": "Payment Partner CSC (Digital Seva Connect) Payment",

        "payment_can_be_done_using": "Payments can be done using UPI / Online Wallets / Debit Cards / Net banking / Credit Cards (As per bank availability)",

        "make_payment": "Make Payment",

        "please_select_a_bank": "Please select a bank",





        //################### Transaction Charges

        "transaction_charges": "Transaction Charges",

        "s_no": "Sr. No.",

        "payment_mode": "Payment Mode",

        "rate_of_transaction": "Rate of Transactions (Excluding GST)",

        "debit_card_rupay": "Debit Card (Rupay)*",

        "as_per_rbi_nil": "As Per RBI (Nil)",

        "debit_card_visa_master": "Debit Card (VISA/ MASTER)",

        "upto_2000": "Upto Rs. 2000/-",

        "above_200": "Above Rs. 2000/-",

        "as_per_rbi_0_40": "As Per RBI (0.40%)",

        "as_per_rbi_0_90": "As Per RBI (0.90%)",

        "credit_card": "Credit Card",

        "unified_payment_interface": "Unified Payments Interface (UPI)*",

        "wallets": "Wallets",

        "internet_banking": "Internet Banking",

        "rs_16": "Rs 16",





        //################payment-response



        "payment": "Payment",

        "successful": "successful",
        "success ": "success ",
        "failed": "failed",
        "initiated ": "initiated ",
        "refunded ": "refunded ",
        "aborted ": "aborted ",


        "reference_number": "Reference Number",

        "your_payment_is": "Your payment is",

        "please_find_the_detail": "Please find the details below",

        "mobile_no_email": "Mobile No.",

        "data_time": "Date & Time",

        "amount": "Amount",

        "payment_bank_name": "Payment Bank Name",

        "payment_status": "Payment Status",

        "exit": "Exit",





        //############## transaction Enquery

        "check_payment_status": "Check Payment Status",

        "view": "View",

        "payment_receipt": "Payment Receipt",

        "payment_related_support": "Payment Related Support Helpline",
        "payment_partner_bank": "Payment Partner",
        "bank_name": "Canara Bank",
        "email_id": "Email ID",
        "alert_msg": "प्रीमियम संग्रह पोर्टल 30/11/2026 तक परिचालन में रहेगा, जो पॉलिसी अवधि 01/11/2026 से 31/10/2027 के लिए लागू होगी।  /  The premium collection portal shall remain operational until 30/11/2026 for policy period 01/11/2026 to 31/10/2027."

    },





    "hi": {

        // #############घर

        "select_language": "भाषा चुनें",

        "chirayu_haryana_pmjay": "चिरायु हरियाणा प्रधानमंत्री जन आरोग्य योजना",

        "nominal_contribution_collection": "नाममात्र योगदान संग्रह",

        "click_to_apply": "आवेदन के लिए क्लिक करें",

        "undertaking": "प्रतिज्ञान",

        "undertaking_intro": "मैं घोषणा एवं वचन देता/देती हूँ कि मैंने चिरायु – आयुष्मान भारत प्रधानमंत्री जन आरोग्य योजना (PM-JAY) के अंतर्गत अपने नामांकन से संबंधित निम्नलिखित नियम एवं शर्तों को पढ़ एवं समझ लिया है:",

        "pmjay_chirayu": "1. चिरायु – आयुष्मान भारत प्रधानमंत्री जन आरोग्य योजना के अंतर्गत सूचीबद्ध (Empanelled) अस्पतालों द्वारा योजना के लागू दिशा-निर्देशों एवं शर्तों के अधीन प्रत्येक परिवार को प्रति वर्ष ₹5,00,000/- (रुपये पाँच लाख मात्र) तक की द्वितीयक एवं तृतीयक स्वास्थ्य सेवाएं कैशलेस प्रदान की जाएंगी।",

        "under_the_scherme": "2. लाभार्थी परिवार की पात्रता फैमिली आईडी (परिवार पहचान पत्र – PPP ID) में दर्ज सत्यापित वार्षिक पारिवारिक आय के आधार पर निर्धारित की जाएगी। लागू वार्षिक पंजीकरण शुल्क निम्नानुसार है:",

        "fee_table_income_header": "सत्यापित वार्षिक पारिवारिक आय",

        "fee_table_fee_header": "प्रति परिवार प्रति वर्ष पंजीकरण शुल्क",

        "fee_slab_1_income": "₹1.80 लाख से ₹3.00 लाख तक",

        "fee_slab_1_fee": "₹1,500/-",

        "fee_slab_2_income": "₹3.00 लाख से अधिक एवं ₹6.00 लाख तक",

        "fee_slab_2_fee": "₹4,000/-",

        "fee_slab_3_income": "₹6.00 लाख से अधिक",

        "fee_slab_3_fee": "₹5,000/-",

        "a_nominal_contribution": "3. मैं समझता/समझती हूँ कि पात्र लाभार्थी परिवार के रूप में चिरायु योजना के अंतर्गत स्वास्थ्य कवरेज प्राप्त करने के लिए मुझे निर्धारित वार्षिक पंजीकरण शुल्क जमा करना आवश्यक है।",

        "portal_open_until": "4. मैं समझता/समझती हूँ कि निर्धारित पंजीकरण शुल्क जमा करने हेतु पोर्टल 30.11.2026 तक खुला रहेगा। निर्धारित अंतिम तिथि के पश्चात पोर्टल बंद कर दिया जाएगा तथा पोर्टल के माध्यम से भुगतान/नामांकन संभव नहीं होगा, जो समय-समय पर जारी लागू आदेशों/दिशा-निर्देशों के अधीन होगा।",

        // "baneficiary_family_shall": "4. लाभार्थी परिवार 15/08/2023 से नाममात्र योगदान-सह-पंजीकरण शुल्क का भुगतान करेंगे और जब तक हम अगली सूचना नहीं देंगे तब तक जारी रखेंगे।",

        "after_successful": "5. पात्रता के सफल सत्यापन एवं निर्धारित पंजीकरण शुल्क प्राप्त होने के पश्चात चिरायु कार्ड/स्वास्थ्य कवरेज की वैधता 01.11.2026 से 31.10.2027 तक रहेगी, जो योजना के लागू दिशा-निर्देशों एवं नियमों/शर्तों के अधीन होगी।",

        "during_validity_period": "6. उक्त वैधता अवधि के दौरान मैं तथा मेरे परिवार के पात्र सदस्य योजना के अंतर्गत सूचीबद्ध अस्पतालों में कैशलेस उपचार प्राप्त करने के हकदार होंगे, जो योजना के अंतर्गत निर्धारित पैकेज, पात्रता तथा अन्य लागू नियमों एवं शर्तों के अधीन होगा।",

        "confirm_ppp_information": "7. मैं पुष्टि करता/करती हूँ कि मेरी फैमिली आईडी (PPP ID) में उपलब्ध जानकारी मेरी सर्वोत्तम जानकारी एवं विश्वास के अनुसार सही है। मैं समझता/समझती हूँ कि योजना के अंतर्गत पात्रता एवं लागू पंजीकरण शुल्क का निर्धारण निर्धारित प्रणाली/पोर्टल में उपलब्ध सत्यापित जानकारी के आधार पर किया जाएगा।",

        "six_line": "5. जो भी लाभार्थी परिवार 1 जनवरी से 31 मार्च, 2024 के बीच भुगतान करेगा, उसे 1 अप्रैल, 2024 से लाभ मिलना शुरू हो जाएगा।",

        "voluntarily_deposit_fee": "8. मैं निर्धारित पंजीकरण शुल्क स्वेच्छा से जमा करता/करती हूँ तथा चिरायु – आयुष्मान भारत प्रधानमंत्री जन आरोग्य योजना के सभी लागू नियमों एवं शर्तों का पालन करने के लिए सहमत हूँ।",

        "i_hereby_submit": "मैंने उपरोक्त सभी नियमों और शर्तों को ध्यानपूर्वक पढ़ लिया है और उन्हें समझ लिया है। मैं यहां पर पीएम-जेएवाय चिरायु योजना के अंतर्गत स्वास्थ्य लाभ प्राप्त करने के लिए, सफल सत्यापन और पंजीकरण शुल्क के भुगतान के अधीन, अपनी पूर्ण सहमति प्रदान करता/करती हूँ।",

        "agree_and_continue": "सहमत और जारी रखें",

        "please_accept_the": "कृपया नियम और शर्तें स्वीकार करें",



        // ###############लेन-देन पूछताछ

        "no_data_found": "कोई डेटा नहीं मिला",

        "transaction_id_length_exceed": "लेन-देन आईडी की लंबाई अधिक",

        "required": "आवश्यक",

        "transaction_id": "लेन-देन आईडी",

        "ppp_id": "पीपीपी आईडी",

        "print": "प्रिंट करें",

        "close": "बंद करें",



        //############ppp-सत्यापन - विवरण सत्यापित करें

        "enter_the_otp": "वैध ओटीपी दर्ज करें",

        "enter_details": "विवरण दर्ज करें",

        "please_enter_ppp_id": "कृपया पीपीपी आईडी दर्ज करें",

        "ppp_id_length_exceed": "पीपीपी आईडी की लंबाई अधिक",

        "please_enter_uid": "कृपया यूआईडी दर्ज करें",

        "invalid_uid": "अमान्य यूआईडी",

        "enter_valid_8_digit_ppp": "मान्य 8 अंकों वाली पीपीपी आईडी दर्ज करें",

        "uid_required": "यूआईडी की आवश्यकता है",

        "your_pppid_aadhar": "आपकी पीपीपी आईडी / आधार नंबर",

        "search_ppp_id": "आपकी पीपीपी आईडी",

        "search_aadhar_number": "आपकी यूआईडी",

        "otp_length": "ओटीपी केवल 6 अंकों का होना चाहिए",

        "enter_uid": "यूआईडी दर्ज करें",

        "verified": "सत्यापित हुआ",

        "verify": "सत्यापित करें",

        "submit": "प्रस्तुत करें",

        "we_will_send_you_a": "हम आपको पंजीकृत मोबाइल नंबर पर सत्यापन कोड भेजेंगे, पीपीपी आईडी को सत्यापित करने के लिए",

        "continue": "जारी रखें",

        "enter_the_pppid_or_aadhar_num": "पीपीपी आईडी दर्ज करें",

        "i_forgot_my_ppp": "मैंने अपना पीपीपी आईडी भूल गया (यूआईडी के माध्यम से खोजें)",

        "please_select_the_option": "कृपया विकल्प चुनें",

        "otp_verification": "ओटीपी सत्यापन",

        "enter_otp": "ओटीपी दर्ज करें",

        "do_not_recevie_the_otp": "क्या आपने ओटीपी प्राप्त नहीं की?",

        "resend": "पुन: भेजें",

        // "verify": "सत्यापित करें",

        "aadhar_number": "आधार नंबर",



        //###########पूर्वावलोकन-विवरण

        "ppp_details": "पीपीपी विवरण",

        "ppp_id_number": "पीपीपी आईडी नंबर",

        "id": "आईडी",

        "name": "नाम",

        "district": "जिला",

        "sub_district": "उप-जिला",

        "linked_member_info": "जुड़े हुए सदस्य की जानकारी",

        "proceed_further_for_payment": "भुगतान के लिए आगे बढ़ें",

        "note_for_pppid_related": "नोट: पीपीपी आईडी संबंधित शिकायत (https://grievance.edisha.gov.in/)",

        "check_eligibility": "पात्रता देखें",

        "family_head_name": "परिवार के प्रमुख का नाम",

        "address": "पता",

        "family_income": "परिवार की आय",



        //################ पेमेंट-हैंडलर

        "payment_details": "भुगतान विवरण",

        "payment_for": "के लिए भुगतान",

        // "ppp_id" : "पीपीपी आईडी",

        "amount_to_be_paid": "भुगतान की जाने वाली राशि",

        "currency": "₹",

        "payment_partner": "भुगतान साथी केनरा बैंक",
        "payment_partner_csc": "भुगतान भागीदार सीएससी (डिजिटल सेवा कनेक्ट) भुगतान",

        "payment_can_be_done_using": "भुगतान करने के लिए यूपीआई / ऑनलाइन वॉलेट / डेबिट कार्ड / नेट बैंकिंग / क्रेडिट कार्ड का उपयोग किया जा सकता है (बैंक की उपलब्धता के अनुसार)",

        "make_payment": "भुगतान करें",

        "please_select_a_bank": "कृपया एक बैंक का चयन करें",



        //################### लेन-देन शुल्क

        "transaction_charges": "लेन-देन शुल्क",

        "s_no": "क्र.सं.",

        "payment_mode": "भुगतान मोड",

        "rate_of_transaction": "लेन-देन दर (जीएसटी से बाहर)",

        "debit_card_rupay": "डेबिट कार्ड (रुपे)*",

        "as_per_rbi_nil": "आरबीआई के अनुसार (शून्य)",

        "debit_card_visa_master": "डेबिट कार्ड (वीजा/ मास्टर)",

        "upto_2000": "₹2000/- तक",

        "above_200": "₹2000/- से ऊपर",

        "as_per_rbi_0_40": "आरबीआई के अनुसार (0.40%)",

        "as_per_rbi_0_90": "आरबीआई के अनुसार (0.90%)",

        "credit_card": "क्रेडिट कार्ड",

        "unified_payment_interface": "एकीकृत भुगतान इंटरफ़ेस (यूपीआई)*",

        "wallets": "वॉलेट",

        "internet_banking": "इंटरनेट बैंकिंग",

        "rs_16": "₹16",



        //################पेमेंट-प्रत्युत्तर

        "payment": "भुगतान",

        "successful": "सफल",
        "success ": "सफलता ",
        "failed": "असफल",
        "initiated ": "प्रारंभिक ",
        "refunded ": "वापस ",
        "aborted ": "रद्द ",


        "reference_number": "संदर्भ संख्या",

        "your_payment_is": "आपका भुगतान",

        "please_find_the_detail": "कृपया नीचे विवरण देखें",

        "mobile_no_email": "मोबाइल नंबर",

        "data_time": "तारीख और समय",

        "amount": "राशि",

        "payment_bank_name": "भुगतान बैंक का नाम",

        "payment_status": "भुगतान स्थिति",

        "exit": "बाहर निकलें",



        //############## लेन-देन पूछताछ

        "check_payment_status": "भुगतान स्थिति जांचें",

        "view": "देखें",

        "payment_receipt": "भुगतान रसीद",

        "payment_related_support": "भुगतान संबंधित सपोर्ट हेल्पलाइन",
        "payment_partner_bank": "भुगतान साथी",
        "bank_name": "कैनरा बैंक",
        "email_id": "ईमेल आईडी",
        "alert_msg": "प्रीमियम संग्रह पोर्टल 30/11/2026 तक परिचालन में रहेगा, जो पॉलिसी अवधि 01/11/2026 से 31/10/2027 के लिए लागू होगी।  /  The premium collection portal shall remain operational until 30/11/2026 for policy period 01/11/2026 to 31/10/2027."
    }

}


export const currentSiteLanguage = () => {
    const searchParam = window.location.search.slice(1)
    const queryString = new URLSearchParams(searchParam?.toString());
    const queryStringData = Object.fromEntries(queryString.entries());
    const hasQueryParam = queryString.has('lang');
    if (!hasQueryParam) {
        return "hi"
    } else {

        return queryStringData?.lang
    }

}




